// extracted by mini-css-extract-plugin
var _1 = "DocFlowAddRecipientFields-moduledivider__LHR7i Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
